/** The VAT rates a product may have, basis points — the API's list (R0030 Q-06). */
export const VAT_RATES: Array<number> = [2300, 1900, 500, 0];

/**
 * The price without VAT of a gross price, rounded half up to the cent — the API's rule, repeated here only to
 * show the net price while the form is typed in; the API computes what is stored and shown afterwards.
 */
export const netFromGross = (grossMinor: number | null, vatRateBasisPoints: number): number | null => {
  if (grossMinor === null) {
    return null;
  }

  const divisor = 10000 + vatRateBasisPoints;

  return Math.floor((2 * grossMinor * 10000 + divisor) / (2 * divisor));
};

/**
 * The price of one unit (R0030 WP-07): a gross price ÷ the quantity of the unit it is for, rounded half up — the
 * API's rule, repeated to show the unit price while the form is typed in.
 */
export const unitPriceOf = (grossMinor: number | null, unitQuantity: number | null): number | null => {
  if (grossMinor === null || unitQuantity === null || unitQuantity <= 0) {
    return null;
  }

  const thousandths = Math.round(unitQuantity * 1000);

  return Math.floor((2 * grossMinor * 1000 + thousandths) / (2 * thousandths));
};

export type SaleState = 'NONE' | 'ALWAYS' | 'ENDED' | 'RUNNING' | 'COMING';

/** Where a sale stands at `now`: none, always on, over, on, or still to come. */
export const saleState = (
  salePriceMinor: number | null,
  saleFrom: string | null,
  saleTo: string | null,
  now: Date,
): SaleState => {
  if (salePriceMinor === null) {
    return 'NONE';
  }

  if (saleFrom === null && saleTo === null) {
    return 'ALWAYS';
  }

  if (saleTo !== null && new Date(saleTo).getTime() < now.getTime()) {
    return 'ENDED';
  }

  return saleFrom !== null && new Date(saleFrom).getTime() > now.getTime() ? 'COMING' : 'RUNNING';
};
